// extracted by mini-css-extract-plugin
export default {"footerBg":"o-z","footerTopLinks":"p-z","footerFeedback":"q-z","footerSocial":"r-z","footerLegalLinks":"s-z","footerIconCards":"t-z","footerBotCopy":"u-z","screenReadersOnly":"v-z"};